import { NgClass } from '@angular/common';
import { Component, Input } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { DebtorAccount } from '@boels/models';
import { NgSelectModule } from '@ng-select/ng-select';
import { TRANSLOCO_SCOPE, TranslocoModule } from '@jsverse/transloco';

@Component({
  selector: 'boels-debtor-select',
  templateUrl: './debtor-select.component.html',
  styleUrls: ['./debtor-select.component.scss'],
  imports: [
    MatCheckboxModule,
    NgClass,
    NgSelectModule,
    TranslocoModule,
    ReactiveFormsModule,
  ],
  providers: [
    {
      provide: TRANSLOCO_SCOPE,
      useValue: ['checkout'],
    },
  ],
})
export class DebtorSelectComponent {
  @Input() debtorForm: FormGroup;
  @Input() debtorFormControl: FormControl;
  @Input() debtorFormControlName: string;
  @Input() debtorAccounts: Array<DebtorAccount>;
  @Input() invalidClass: boolean;
  @Input() isMobile: boolean;

  searchFilter(term: string, item: DebtorAccount) {
    term = term.toLowerCase();
    return (
      item.name.toLowerCase().includes(term) ||
      item.debtorNumber.toLowerCase().includes(term)
    );
  }
}
